module.exports = __webpack_public_path__ + "static/card-1c50a98a75723653a0700760d33be180.png";